// extracted by mini-css-extract-plugin
export default {"BackToRepositorySelectionButton":"RepositoryAndIssuePicker-module__BackToRepositorySelectionButton--b4A8b"};